import { render, staticRenderFns } from "./coderOutpatientDemographics.vue?vue&type=template&id=45c25ab9&scoped=true&"
import script from "./coderOutpatientDemographics.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientDemographics.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientDemographics.vue?vue&type=style&index=0&id=45c25ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c25ab9",
  null
  
)

export default component.exports